
let token;

function setUtilsToken(t) {
  token = t;
}

async function sendPost(token, url, payload) {
  if (token) {
    setUtilsToken(token);
  }
  await sendPostRequest(url, payload);
}

async function sendPostRequest(url, payload) {
  const headers = {
    "Content-Type": "application/json"
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const r = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: headers
  });
  console.log(r);
  if (r.ok) {
    if (r.status === 200) {
      const data = await r.json();
      return data;  
    }
  }
  else {
    throw {
      status: r.status
    }
  }
}

async function sendGetRequest(url) {
  try {
    const r = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!r.ok) {
      if (r.status === 403) {
        throw {
          status: 403,
          statusText: 'Forbidden'
        }
      }
      let d;
      try {
        d = await r.json();
      }
      catch (e2) {
        d = await r.text();
      }
      throw {
        data: d,
        status: r.status
      }
    }
    const data = await r.json();
    return data;
  }
  catch (e) {
    console.log(e);
    throw e;
  }
}

async function sendPut(url, payload) {
  const headers = {
    "Content-Type": "application/json"
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const r = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(payload),
    headers: headers
  });
  console.log(r);
  if (r.ok) {
    if (r.status === 200) {
      const data = await r.json();
      return data;  
    }
  }
  else {
    throw {
      status: r.status
    }
  }
}

async function sendDelete(url, payload) {
  const headers = {
    "Content-Type": "application/json"
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const r = await fetch(url, {
    method: 'DELETE',
    body: JSON.stringify(payload),
    headers: headers
  });
  if (r.ok) {
    if (r.status === 200) {
      const data = await r.json();
      return data;  
    }
  }
  else {
    throw {
      status: r.status
    }
  }
}

function renderRoles(roles) {
  let output = '';
  roles.forEach(r => {
    if (output) {
      output += ',';
    }
    output += r.role.label
  });
  return output
}

/**
 * 
 * @param {Date} date 
 * @param {string} format 
 * @returns {string}
 */
function formatDate(date, format) {
  function getDatePartAsTwoDigits(part) {
    if (part < 10) {
      return `0${part}`;
    }
    else {
      return `${part}`
    }
  }

  switch (format) {
    case 'yyyy-mm-dd':
      return `${date.getFullYear()}-${getDatePartAsTwoDigits(date.getMonth() + 1)}-${getDatePartAsTwoDigits(date.getDate())}`;
    default:
      return date.toString();
  }
}

function downloadCsvFile(fileName, content) {
  const universalBOM = "\uFEFF";
  const a = document.createElement('a');
  a.href = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + content);
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/**
 * Function to check if an object has all required keys
 * @param {*} object The object to check
 * @param {String[]} keys The list of keys to check for
 * @returns {boolean}
 */
function hasAllKeys(object, keys) {
  return keys.every(key => Object.hasOwn(object, key));
};

/**
 * Finds keys present in the required keys array but missing from the target object.
 * @param {object} targetObj - The object to check for missing keys.
 * @param {string[]} requiredKeys - An array of all keys that should be present.
 * @returns {string[]} An array of keys missing from the target object.
 */
function findMissingKeys(targetObj, requiredKeys) {
  const targetKeys = Object.keys(targetObj);
  const missingKeys = requiredKeys.filter(key => {
    // Check if the required key is NOT in the target object's keys
    return !targetKeys.includes(key) || !targetObj[key] ;
  });
  return missingKeys;
}

export {
  setUtilsToken,
  sendPost,
  sendPostRequest,
  sendGetRequest,
  sendPut,
  sendDelete,
  renderRoles,
  formatDate,
  downloadCsvFile,
  hasAllKeys,
  findMissingKeys
}